module.exports = "img/waldorf.a91a77.jpg";